import React from 'react'
import styles from './styles.css'

export default function StatusBadge({active, small}) {
  const className = [styles.status, active ? styles.active : styles.inactive, small && styles.small]
    .filter(Boolean)
    .join(' ')
  return <div className={className}></div>
}
